import React from "react";
import {GlucoseForm} from "./GlucoseForm";
import {TemperatureForm} from "./TemperatureForm";
import {BloodPressureForm} from "./BloodPressureForm";
import {PulseForm} from "./PulseForm";
import {BloodOxygenForm} from "./BloodOxygenForm";

export const MeasureForm = ({
  measurement,
  onChangeMeasurement,
}) => ({
  bp: (
    <BloodPressureForm
      measurement={measurement}
      onChangeMeasurement={onChangeMeasurement}
    />
  ),
  glucose: (
    <GlucoseForm
      measurement={measurement}
      onChangeMeasurement={onChangeMeasurement}
    />
  ),
  temp: (
    <TemperatureForm
      measurement={measurement}
      onChangeMeasurement={onChangeMeasurement}
    />
  ),
  pulse: (
    <PulseForm
      measurement={measurement}
      onChangeMeasurement={onChangeMeasurement}
    />
  ),
  oxygen: (
    <BloodOxygenForm
      measurement={measurement}
      onChangeMeasurement={onChangeMeasurement}
    />
  )
})